<template>
    <DModal
        :show="showModal"
        :title="title"
        is-confirm
        :is-awaiting-validation="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="saveReason"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <DFormRow
                :label="label"
                :error="errors[formData.field]"
            >
                <DInput
                    v-if="inputType === 'number'"
                    :id="formData.field+'_number'"
                    v-model="formData[formData.field]"
                    maxlength="1"
                />
                <DInput
                    v-else-if="inputType === 'string'"
                    :id="formData.field+'_string'"
                    v-model="formData[formData.field]"
                    maxlength="255"
                />
                <DFormTextarea
                    v-else-if="inputType === 'textarea'"
                    :id="formData.field+'_textarea'"
                    v-model="formData[formData.field]"
                    rows="3"
                    maxlength="255"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'PsaAdditionalInfoModal',
    props: {
        order: {
            type: Object,
            default: () => { return {} }
        },
        form: {
            type: Object,
            default: () => { return {} }
        },
        title: {
            type: String,
            default: () => { return null }
        },
        label: {
            type: String,
            default: () => { return null }
        },
        inputType: {
            type: String,
            default: () => { return null }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            formData: this.form,
            errors: {}
        }
    },
    methods: {
        saveReason () {
            this.$inertia.post(
                this.$route('orders.psa.save_additional_info', {
                    order: this.order.orderData.id
                }),
                this.formData,
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                    },
                    onError: (error) => {
                        this.errors = error
                    }
                }
            )
        }
    }
}
</script>

<style scoped>
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
